import { FloorplanResponse } from '@domain/floorplan';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

const getFloorplan = async (floorplanId: string | null | undefined) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplans/${floorplanId}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetFloorplan = ({ floorplanId }: { floorplanId: string | null | undefined }) => {
  return useGenericQuery<FloorplanResponse, RequestError>(
    [QUERY_KEYS.getFloorplan, floorplanId],
    () => getFloorplan(floorplanId),
    {
      enabled: !!floorplanId,
    }
  );
};
